import React, { useEffect, ComponentProps } from 'react';
import { useAuthentication } from '../../../Login/hooks/useAuthentication';
import { ApplicationEntrySaveAndExitButton } from './components/ApplicationEntrySaveAndExitButton';
import { ApplicationEntryNavigationButtons } from './components/ApplicationEntryNavigationButtons/ApplicationEntryNavigationButtons';
import { ApplicationEntryPropertyDeleteButton } from './components/ApplicationEntryPropertyDeleteButton';
import {
    ProgressBreadcrumbList,
    ProgressBreadcrumbListTheme,
    ProgressBreadcrumbCompletedDisplayStyle,
    ProgressBreadcrumb,
    Button,
    AddressLocation,
} from '@apply/components';

type ProgressBreadcrumbProps = ComponentProps<typeof ProgressBreadcrumb>;
type ButtonProps = ComponentProps<typeof Button>;
export interface MobileApplicationEntryPanelProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children: any;
    sections: ProgressBreadcrumbProps[];
    currentSection: number;
    printMode?: boolean;
    saveAndExitButtonProps: ButtonProps;
    nextStepButtonProps: ButtonProps;
    deletePropertyButtonProps?: ButtonProps;
    previousStepButtonVisible?: boolean;
    previousStepButtonClick?: React.MouseEventHandler;
    propertyAddress?: string;
}

export const MobileApplicationEntryPanel: React.FC<MobileApplicationEntryPanelProps> = ({
    children,
    sections,
    currentSection,
    saveAndExitButtonProps,
    nextStepButtonProps,
    deletePropertyButtonProps,
    previousStepButtonVisible,
    previousStepButtonClick,
    propertyAddress,
    printMode = false,
}) => {
    const { authentication, isAuthenticated } = useAuthentication();

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    return (
        <>
            <div className='applicationEntry-mobile'>
                <div className='applicationEntry-mobile-appWrapper'>
                    <div className='applicationEntry-mobile-header'>
                        <div className='applicationEntry-mobile-header-image'>
                            <img
                                src='/assets/img/logo.webp.html'
                                alt='Builder Finance'
                                height='38px'
                            />
                        </div>
                        <div className='applicationEntry-mobile-header-topButton'>
                            <ApplicationEntrySaveAndExitButton
                                saveAndExitButtonProps={saveAndExitButtonProps}
                                printMode={printMode}
                            />
                            {deletePropertyButtonProps && (
                            <ApplicationEntryPropertyDeleteButton
                                deletePropertyButtonProps={deletePropertyButtonProps}
                                printMode={printMode}
                            />)}
                        </div>
                    </div>
                    <div className='applicationEntry-mobile-contextIndicator'>
                        <div className='applicationEntry-mobile-contextIndicator-process'>Apply</div>
                        <div className='applicationEntry-mobile-contextIndicator-addressLocator'>
                            {propertyAddress && (
                                <AddressLocation
                                    addressLine1={propertyAddress}
                                    addressLine2=''
                                />
                            )}
                        </div>
                    </div>
                    <div className='applicationEntry-mobile-progressIndicator'>
                        <ProgressBreadcrumbList
                            id='applicationEntrySidebarVerticalBreadcrumb'
                            theme={ProgressBreadcrumbListTheme.Blue}
                            activeCrumbNumber={currentSection}
                            crumbs={sections}
                            orientation='horizontal'
                            completedCrumbDisplayStyle={ProgressBreadcrumbCompletedDisplayStyle.Checkmark}
                        />
                    </div>
                    <div className='applicationEntry-mobile-appWrapper-contentWrapper'>
                        <div className='applicationEntry-mobile-appWrapper-content'>{children}</div>
                    </div>
                    <div className='applicationEntry-mobile-appWrapper-navigationButtons'>
                        <ApplicationEntryNavigationButtons
                            nextStepButtonProps={nextStepButtonProps}
                            previousStepButtonVisible={previousStepButtonVisible}
                            previousStepButtonClick={previousStepButtonClick}
                            printMode={printMode}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
